import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'

import Box from 'components/box'
import ValueLabel from 'components/value-label'
import EventReviewListButton from 'components/event-review-list-button'

import styles from './event-review-list-item.css'

const EventReviewListItem = ({
  name,
  url,
  venue,
}) => (
  <a href={url} styleName="event-review-list-item">
    <Box interactive>
      <div styleName="wrapper">
        <Relayout gutter={false} valign="middle">
          <RelayoutItem sm="12" lg="9">
            <div styleName="title">
              <ValueLabel label={venue} value={name} />
            </div>
          </RelayoutItem>
          <RelayoutItem sm="12" lg="3" styleName="action-wrapper">
            <div styleName="action">
              <EventReviewListButton label="View Summary" />
            </div>
          </RelayoutItem>
        </Relayout>
      </div>
    </Box>
  </a>
)

EventReviewListItem.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
  venue: PropTypes.string,
}

export default CSSModules(EventReviewListItem, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/event-review-list-item/event-review-list-item.js
 **/